var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseMultiselect,{attrs:{"label":_vm.sga ? 'Evento SGA' : 'Evento LFP',"name":_vm.sga ? 'sga_id' : 'lfp_id',"value":_setup.selected?.id ?? null,"options":_setup.events || [],"label-key":_vm.sga ? 'name' : 'nombre',"value-key":"id","rules":!_vm.evento.experiencia ? 'required' : ''},on:{"input":_setup.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }